<template>
  <v-row :class="defaultMargin">
    <v-btn-toggle>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="white" @click="OntogglePage" v-bind="attrs" v-on="on">
            <v-icon>
              {{
                page === "hab"
                  ? "mdi-format-list-bulleted"
                  : "mdi-card-text-outline"
              }}</v-icon
            >
          </v-btn>
        </template>
        <span>{{ page === "hab" ? "HAB History" : "HAB Card" }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="white"
            @click="OntoggleUnsignedPage()"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-format-list-text</v-icon>
          </v-btn>
        </template>
        <span>Unsigned HAB</span>
      </v-tooltip>
    </v-btn-toggle>
  </v-row>
</template>

<script>
export default {
  props: {
    defaultMargin: {
      type: String,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    page: {
      type: String,
    },
  },

  data() {
    return {};
  },
  methods: {
    OntoggleUnsignedPage() {
      this.$emit("toggle-unsigned-page");
    },
    OntogglePage() {
      this.$emit("toggle-page");
    },
  },
};
</script>
